import React, { useState } from 'react';

const StudentGrades = ({ grades, sessions }) => {
  const [expandedSessions, setExpandedSessions] = useState({});

  const toggleSession = (sessionId) => {
    setExpandedSessions((prev) => ({
      ...prev,
      [sessionId]: !prev[sessionId],
    }));
  };

  // Compute overall total points
  const totalPoints = Object.values(grades).reduce(
    (sum, session) =>
      sum + Object.values(session.points || {}).reduce((s, p) => s + p, 0),
    0
  );

  // Prepare sessions list with dates
  const sessionEntries = sessions ? sessions.map((session) => [session.id, session]) : [];

  return (
    <div className="w-full min-w-0 p-3 sm:p-4">
      <h3 className="text-xl font-semibold mb-4" style={{ color: 'var(--text-color)' }}>
        Your Grades
      </h3>
      <h5 className="text-lg mb-6" style={{ color: 'var(--text-color)' }}>
        Total Points: {totalPoints.toFixed(2)}
      </h5>
      <div className="overflow-x-auto">
        <table className="w-full border-collapse">
          <thead className="bg-[var(--card-hover-bg)]">
            <tr>
              <th className="p-2 border-b border-[var(--muted-color)] text-[var(--text-color)]">
                Session Date
              </th>
              <th className="p-2 border-b border-[var(--muted-color)] text-[var(--text-color)]">
                Session Total Points
              </th>
              <th className="p-2 border-b border-[var(--muted-color)] text-[var(--text-color)]">
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {sessionEntries.map(([sessionId, session]) => {
              const sessionData = grades[sessionId];
              const sessionDate = session?.start_date_time
                ? new Date(session.start_date_time).toLocaleDateString()
                : 'Unknown Date';
              const sessionTotalPoints = sessionData
                ? Object.values(sessionData.points || {}).reduce((sum, p) => sum + p, 0)
                : null;
              const isExpanded = expandedSessions[sessionId];

              return (
                <React.Fragment key={sessionId}>
                  <tr className="bg-[var(--card-bg)] hover:bg-[var(--card-hover-bg)]">
                    <td className="p-2 border-b border-[var(--muted-color)]" style={{ color: 'var(--text-color)' }}>
                      {sessionDate}
                    </td>
                    <td className="p-2 border-b border-[var(--muted-color)]" style={{ color: 'var(--text-color)' }}>
                      {sessionTotalPoints !== null ? sessionTotalPoints.toFixed(2) : 'Not attended'}
                    </td>
                    <td className="p-2 border-b border-[var(--muted-color)]">
                      {sessionData ? (
                        <button
                          onClick={() => toggleSession(sessionId)}
                          className="px-3 py-1 rounded transition-colors border border-[var(--primary-color)] text-[var(--text-color)] hover:bg-[var(--primary-color)] hover:text-white"
                        >
                          {isExpanded ? 'Collapse' : 'Expand'}
                        </button>
                      ) : (
                        <span style={{ color: 'var(--muted-color)' }}>N/A</span>
                      )}
                    </td>
                  </tr>
                  {isExpanded &&
                    sessionData &&
                    Object.entries(sessionData.points || {}).map(([questionNumber, point]) => (
                      <tr
                        key={`${sessionId}-${questionNumber}`}
                        className="bg-[var(--card-bg)] hover:bg-[var(--card-hover-bg)]"
                      >
                        <td
                          className="p-2 pl-8 border-b border-[var(--muted-color)]"
                          style={{ color: 'var(--text-color)' }}
                        >
                          Question {questionNumber}
                        </td>
                        <td
                          className="p-2 border-b border-[var(--muted-color)]"
                          style={{ color: 'var(--text-color)' }}
                        >
                          {typeof point === 'number' ? point.toFixed(2) : point}
                        </td>
                        <td className="p-2 border-b border-[var(--muted-color)]"></td>
                      </tr>
                    ))}
                </React.Fragment>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default StudentGrades;
